import { Image } from "@/components/Elements";
import { InputField } from "@/components/Form";
import { useMemo, useState } from "react";
import { RecipientModel } from "@/types/chat";
import { FriendSuggestionModel } from "../../types/friend";
import { ListRenderItem } from "@/types/common";
import { contains } from "@/utils/helper";

export const FriendList = ({
  friendList,
  Item,
}: {
  friendList: RecipientModel[] | FriendSuggestionModel[];
  Item: ListRenderItem<any>;
}) => {
  const [searchBy, setSearchBy] = useState("");

  const recipients = useMemo(() => {
    let list: any = friendList;
    if (searchBy) {
      list = list.filter((c: any) => contains(c.fullName, searchBy));
    }
    return list;
  }, [friendList, searchBy]);

  return (
    <div className="flex-1 p-[5px]">
      <div>
        <InputField
          type="text"
          placeholder="Search..."
          value={searchBy}
          registration={{
            onChange: async (event) => setSearchBy(event.target.value),
          }}
          icon={
            <Image src="search-small-icon.png" className="w-[24px] h-[24px]" />
          }
        />
      </div>
      <div className="flex-1 mt-[10px]">
        {recipients.map((item: any) => (
          <Item item={item} key={item.userId} />
        ))}
      </div>
    </div>
  );
};
